import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7419168"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search middle" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "search-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Data Plans and prices", -1))
const _hoisted_5 = {
  key: 0,
  class: "data-plans-slider"
}
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-text mb-4" }, " Unable to find esim for your request. Please try again ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex flex-column align-items-center" }
const _hoisted_10 = {
  key: 1,
  class: "container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "search__label" }, "Where are you going?", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "search__label" }, "How long do you need the eSIM?", -1))
const _hoisted_13 = { class: "search-bottom-row" }
const _hoisted_14 = ["disabled"]

import SearchCountries from "@/components/search/SearchCountries.vue";
import SearchDuration from "@/components/search/SearchDuration.vue";
import { nextTick, ref, Ref } from "vue";
import MainLoader from "@/components/MainLoader.vue";
import { useBundleStore } from "@/stores/bundle";
import BundleCard from "@/components/bundle/BundleCard.vue";
import SearchIcon from "@/components/icons/SearchIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {

const bundleStore = useBundleStore();

const searchLoading: Ref<boolean> = ref(false);
const searchResult: Ref<HTMLDivElement | null> = ref(null);

async function searchBundles(): Promise<void> {
  searchLoading.value = true;
  await bundleStore.getBundles(
    bundleStore.duration || 1,
    bundleStore.countries
  );
  searchLoading.value = false;

  await nextTick(() => {
    if (searchResult.value) {
      setTimeout(
        () =>
          document.documentElement.scrollTo({
            top: (searchResult.value?.offsetTop || 30) - 30,
            behavior: "smooth",
          }),
        100
      );
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bundleStore).firstLoaded && !searchLoading.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "data-plans-group",
          ref_key: "searchResult",
          ref: searchResult
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("button", {
                class: "search-back",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(bundleStore).clearBundles && _unref(bundleStore).clearBundles(...args)))
              }, [
                _createVNode(SearchIcon, { class: "search-back__icon" })
              ])
            ]),
            (_unref(bundleStore).bundles.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bundleStore).bundles, (bundle, index) => {
                    return (_openBlock(), _createBlock(BundleCard, {
                      key: bundle.id,
                      bundle: bundle,
                      "requested-countries": _unref(bundleStore).countries,
                      primary: index === 0
                    }, null, 8, ["bundle", "requested-countries", "primary"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-b btn-danger mt-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(bundleStore).clearBundles && _unref(bundleStore).clearBundles(...args)))
              }, " New search ")
            ])
          ])
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(SearchCountries, {
            modelValue: _unref(bundleStore).countries,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bundleStore).countries) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(SearchDuration, {
              modelValue: _unref(bundleStore).duration,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bundleStore).duration) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              class: "btn btn-b btn-danger search__find",
              disabled: 
            !_unref(bundleStore).duration ||
            !_unref(bundleStore).countries.length ||
            searchLoading.value
          ,
              onClick: searchBundles
            }, [
              _createTextVNode(" Find me the best offer "),
              (searchLoading.value)
                ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_14)
          ])
        ]))
  ]))
}
}

})